export enum CustomAttributesInteractions {
  REMOVED = 'Removed',
  ADDED = 'Added',
  CHANGED = 'Changed',
}
